<template>
  <div v-if="stato === 0">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon color="red" class="material-icons" v-bind="attrs" v-on="on">
          new_releases
        </v-icon>
      </template>
      <span>Nuovo</span>
    </v-tooltip>
  </div>
  <div v-else-if="stato === 2">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon color="green" class="material-icons" v-bind="attrs" v-on="on">
          check_circle
        </v-icon>
      </template>
      <span>Letto da azienda</span>
    </v-tooltip>
  </div>
  <div v-else></div>
</template>

<script>
export default {
  name: "stato-lettura-azienda",
  props: ["stato"], //0 – Nuovo, 2 – Letto da azienda
};
</script>

<style>
</style>
